import { render, staticRenderFns } from "./CrudView.vue?vue&type=template&id=70b4c01b&"
import script from "./CrudView.vue?vue&type=script&lang=js&"
export * from "./CrudView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports